module.exports = __webpack_public_path__ + "static/6-05ccae5ad87952d38c0c490da2294d38.png";